import { render, staticRenderFns } from "./CoreTransactionDetail.vue?vue&type=template&id=2cb07909&scoped=true"
import script from "./CoreTransactionDetail.vue?vue&type=script&lang=js"
export * from "./CoreTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./CoreTransactionDetail.vue?vue&type=style&index=0&id=2cb07909&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb07909",
  null
  
)

export default component.exports